<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          订单类型<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="rpostOrderTypeCode">
            <el-select ref="saleType" v-model="form.rpostOrderTypeCode" placeholder="请选择订单类型" style="width:100%;" @change="change">
              <el-option v-for="option in contratOrderType" :key="option.code" :value="option.code" :label="option.name " />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getOrderTypesBySupplyUnit } from '@/API';
export default {
  data () {
    return {
      OrderType: '',
      contratOrderType: [],
      getForm: {}
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {
  },
  watch: {
    form (val) {
      this.getForm = val;
    }
  },
  methods: {
    changeTaxType (val) {
      this.getContratOrderType(val.supplyUnitId, val.currencyId, true);
    },
    initContratOrderType () {
      this.getContratOrderType(this.form.supplyUnitId, this.form.currencyId, false);
    },
    initContratOrderTypeNew (val) {
      this.getContratOrderType(val.supplyUnitId, val.currencyId, false);
    },
    getContratOrderType (supplyUnitID, currencyId, isChange) {
      if (supplyUnitID && currencyId) {
        getOrderTypesBySupplyUnit(supplyUnitID, currencyId).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            let list = [];
            json.data.forEach((item) => {
              let map = {
                code: item.basicInfoID,
                name: item.basicInfoName
              };
              list.push(map);
            });
            this.contratOrderType = list;
            if (isChange) {
              this.form.rpostOrderTypeCode = '';
            }
          }
        }).catch(() => {
        });
      } else {
        this.form.rpostOrderTypeCode = '';
      }
    },
    initData () {
      if (this.form.OrderType) {
        // this.OrderType = this.form.supplyAddress;
      }
    },
    change (val) {
      this.$nextTick(() => {
        this.form.rpostOrderTypeName = this.$refs.saleType.selectedLabel;
      });
    }
  },
  mounted () {
    this.initContratOrderType();
    // this.initData();
  }
};
</script>
